import React from "react";
import { Link } from "react-router-dom";
import { useBatchTiming } from "./hooks/useBatchTiming";
import { showToast } from "../../../core/utils/alert";

interface BatchTimingModalsProps {
  batchTimingId?: string;
  onDeleteSuccess?: () => void;
}

const BatchTimingModals: React.FC<BatchTimingModalsProps> = ({
  batchTimingId,
  onDeleteSuccess,
}) => {
  const { deleteBatchTiming } = useBatchTiming();

  const handleDelete = async () => {
    if (!batchTimingId) {
      showToast({
        title: "Error",
        text: "No batch timing selected for deletion",
        icon: "error",
      });
      return;
    }

    try {
      const result = await deleteBatchTiming(batchTimingId);
      if (result.success) {
        showToast({
          title: "Success",
          text: "Batch timing deleted successfully!",
          icon: "success",
        });
        if (onDeleteSuccess) {
          onDeleteSuccess();
        }
      }
    } catch (error) {
      showToast({
        title: "Error",
        text: "Failed to delete batch timing",
        icon: "error",
      });
      console.error("Failed to delete batch timing:", error);
    }
  };

  return (
    <>
      {/* Delete Batch Timing Modal */}
      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <span className="delete-icon">
                <i className="ti ti-trash" />
              </span>
              <h4>Delete Batch Timing</h4>
              <p>
                You want to delete this record, this can't be undone once you
                delete.
              </p>
              <div className="d-flex justify-content-center">
                <Link
                  to="#"
                  className="btn btn-light me-3"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={handleDelete}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BatchTimingModals;

export {};
